var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_1374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3638 14.6324C27.3031 12.1131 25.3442 10.0778 22.8672 8.92158C20.3903 7.76541 17.5721 7.57086 14.9598 8.3757C12.3475 9.18053 10.1274 10.9273 8.73064 13.277C7.33383 15.6266 6.85992 18.4115 7.40093 21.0909C7.94193 23.7703 9.45925 26.1531 11.6583 27.7767C13.8574 29.4003 16.5813 30.1488 19.3012 29.877C22.0211 29.6052 24.543 28.3324 26.3773 26.3058C28.2116 24.2791 29.2273 21.6432 29.2274 18.9097C29.2295 17.4404 28.9358 15.9857 28.3638 14.6324ZM16.8437 25.6408L13.9246 23.1351L11.1114 20.7223L13.6099 17.8117L16.1938 20.0293L22.2674 12.1787L25.3636 14.4421L16.8437 25.6408Z",
    fill: "#D19B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3716 18.9188L34.3467 15.7142L34.9952 11.9809L31.9019 9.7924L31.0663 6.09461L27.3685 5.25976L25.1854 2.16144L21.4503 2.80144L18.2467 0.77832L15.0424 2.805L11.3091 2.1561L9.12061 5.24945L5.42282 6.08501L4.58834 9.7828L1.48966 11.9663L2.12966 15.6996L0.105469 18.9032L2.13214 22.1078L1.48325 25.8412L4.5766 28.0296L5.41216 31.7274L9.10995 32.5623L11.2934 35.6606L15.0286 35.0206L18.2325 37.0448L21.4368 35.0181L25.1701 35.667L27.3586 32.5737L31.0564 31.7381L31.8909 28.0403L34.9895 25.8568L34.3495 22.1235L36.3716 18.9188ZM18.2382 31.8046C11.1171 31.8046 5.34424 26.0318 5.34424 18.9103C5.34424 11.7889 11.1171 6.01603 18.2382 6.01603C25.3593 6.01603 31.1324 11.7889 31.1324 18.9103C31.1324 26.0318 25.3596 31.8046 18.2382 31.8046Z",
    fill: "#D19B16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_1374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.2668,
    height: 36.2668,
    fill: "white",
    transform: "translate(0.104736 0.776245)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.b8d01547fd586fbc80c900d9c1ef3844.svg";
export { ForwardRef as ReactComponent };